const ro = {
    Version: 'Versiune',
    'This is the initial version of the platform.': 'Aceasta este versiunea inițială a platformei.',
    Features: 'Caracteristici',
};

export default { ro };
